(function () {
    'use strict';

    angular
        .module('franchisee-portal')
        .config(routes);

    /** @ngInject */
    function routes($urlMatcherFactoryProvider, $stateProvider, $urlRouterProvider, $locationProvider, PATHS) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/not-found');

        $urlMatcherFactoryProvider.type('slashFix', {
            raw: true,
        });

        $stateProvider
            .state('app-master', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/layout-master.html`,
                onEnter: ($rootScope, AuthenticationService, HelperService) => {
                    $rootScope.isOauth = false;

                    return AuthenticationService
                        .handleSystemLoad()
                        .catch(error => {
                            HelperService.handleStateChangeError(error);
                        });
                }
            })
            .state('app-master.default', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/layout-default.html`
            })
            .state('app-master.full-screen', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/layout-full-screen.html`
            })

            .state('app-master.default.not-authorized', {
                title: 'Não Autorizado',
                url: '/not-authorized',
                templateUrl: `${PATHS.PHYSICAL}/components/not-authorized/not-authorized.html`,
                controller: 'NotAuthorizedController',
                controllerAs: 'vm',
                onEnter: $rootScope => {
                    $rootScope.hideSidebar = true;
                }
            })
            .state('app-master.default.not-found', {
                title: 'Não Encontrado',
                url: '/not-found',
                templateUrl: `${PATHS.PHYSICAL}/components/not-found/not-found.html`,
                controller: 'NotFoundController',
                controllerAs: 'vm'
            })

            .state('app-master.default.home', {
                title: 'Home',
                url: '/',
                templateProvider: ($templateRequest, $rootScope) => {
                    const template = `${PATHS.PHYSICAL}/components/home/${$rootScope.isMobile ? 'home.mobile' : 'home'}.html`;

                    return $templateRequest(template);
                },
                controller: 'HomeController',
                controllerAs: 'vm'
            })
            .state('app-master.default.applications', {
                title: 'Aplicativos',
                url: '/applications',
                templateUrl: `${PATHS.PHYSICAL}/components/applications/applications.html`,
                controller: 'ApplicationsController',
                controllerAs: 'vm'
            })

            // COMMUNICATES
            .state('app-master.full-screen.communicates', {
                title: 'Comunicados',
                url: '/communicates/:communicateUrl?NewsId&NewsTitle',
                templateUrl: `${PATHS.PHYSICAL}/components/communicates/communicates.html`,
                controller: 'CommunicatesController',
                controllerAs: 'vm',
                params: {
                    communicateUrl: {
                        dynamic: true,
                        value: null,
                        squash: true
                    }
                }
            })

            // EVENTS
            .state('app-master.default.events-root', {
                title: 'Eventos',
                url: '/events',
                templateUrl: `${PATHS.PHYSICAL}/components/events/events-list.html`,
                controller: 'EventsListController',
                controllerAs: 'vm'
            })
            .state('app-master.default.events', {
                title: 'Eventos',
                url: '/events/{eventPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/events/events-list.html`,
                controller: 'EventsListController',
                controllerAs: 'vm',
                params: {
                    eventPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.events-internal', {
                title: 'Visualizar Evento',
                url: '/events/:eventUrl?NewsId&NewsTitle',
                templateUrl: `${PATHS.PHYSICAL}/components/events/events-internal.html`,
                controller: 'EventsInternalController',
                controllerAs: 'vm'
            })

            // HELPDESK
            .state('app-master.default.helpdesk', {
                title: 'Helpdesk',
                url: '/helpdesk/{helpdeskPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/helpdesk/helpdesk-list.html`,
                controller: 'HelpdeskListController',
                controllerAs: 'vm',
                params: {
                    helpdeskPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.helpdesk-queue', {
                title: 'Helpdesk',
                url: '/helpdesk/queue/{helpdeskPage:int}?getOnlyClosed:bool',
                templateUrl: `${PATHS.PHYSICAL}/components/helpdesk/helpdesk-queue-list.html`,
                controller: 'HelpdeskQueueListController',
                controllerAs: 'vm',
                params: {
                    helpdeskPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                },
                onEnter: ($state, AuthenticationService) => {
                    const person = AuthenticationService.getUserData();

                    if (!person.Responsibility || person.Responsibility.Id == 4)
                        $state.go('app-master.default.helpdesk');
                }
            })
            .state('app-master.default.helpdesk-internal', {
                title: 'Visualizar Chamado',
                url: '/helpdesk/ticket/{ticketId:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/helpdesk/helpdesk-internal.html`,
                controller: 'HelpdeskInternalController',
                controllerAs: 'vm'
            })
            .state('app-master.default.helpdesk-new', {
                title: 'Novo Chamado',
                url: '/helpdesk/new',
                templateUrl: `${PATHS.PHYSICAL}/components/helpdesk/helpdesk-internal.html`,
                controller: 'HelpdeskInternalController',
                controllerAs: 'vm'
            })

            // ARTS SOLICITATION
            .state('app-master.default.arts-solicitation', {
                title: 'Solicitações de Artes',
                url: '/arts-solicitation/{artsSolicitationPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/arts-solicitation/arts-solicitation-list.html`,
                controller: 'ArtsSolicitationListController',
                controllerAs: 'vm',
                params: {
                    artsSolicitationPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.arts-solicitation-queue', {
                title: 'Solicitações de Artes',
                url: '/arts-solicitation/queue/{artsSolicitationPage:int}?getOnlyClosed:bool',
                templateUrl: `${PATHS.PHYSICAL}/components/arts-solicitation/arts-solicitation-queue-list.html`,
                controller: 'ArtsSolicitationQueueListController',
                controllerAs: 'vm',
                params: {
                    artsSolicitationPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                },
                onEnter: ($state, AuthenticationService) => {
                    const personLogged = AuthenticationService.getUserData();
                    let hasPermission = false;

                    if (!personLogged.TicketCategory_Person)
                        return hasPermission;

                    for (let index = 0; index < personLogged.TicketCategory_Person.length; index++) {
                        const ticketCategoryPerson = personLogged.TicketCategory_Person[index];

                        if (ticketCategoryPerson.TicketCategoryId == 2)
                            hasPermission = true;
                    }

                    if (!hasPermission)
                        $state.go('app-master.default.arts-solicitation');
                }
            })
            .state('app-master.default.arts-solicitation-internal', {
                title: 'Visualizar Solicitação de Artes',
                url: '/arts-solicitation/internal/{artSolicitationId:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/arts-solicitation/arts-solicitation-internal.html`,
                controller: 'ArtsSolicitationInternalController',
                controllerAs: 'vm'
            })
            .state('app-master.default.arts-solicitation-new', {
                title: 'Nova Solicitação de Artes',
                url: '/arts-solicitation/new',
                templateUrl: `${PATHS.PHYSICAL}/components/arts-solicitation/arts-solicitation-internal.html`,
                controller: 'ArtsSolicitationInternalController',
                controllerAs: 'vm'
            })

            // FAQ
            .state('app-master.default.faq', {
                title: 'FAQ',
                url: '/faq/:faqCategory/{faqId:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/faq/faq-list.html`,
                controller: 'FaqListController',
                controllerAs: 'vm',
                params: {
                    faqCategory: {
                        dynamic: true,
                        value: null,
                        squash: true
                    },
                    faqId: {
                        dynamic: true,
                        value: null,
                        squash: true
                    }
                }
            })

            // MEDIA
            .state('app-master.default.media-root', {
                title: 'Mídia',
                url: '/media',
                templateUrl: `${PATHS.PHYSICAL}/components/media/media-list.html`,
                controller: 'MediaListController',
                controllerAs: 'vm'
            })
            .state('app-master.default.media', {
                title: 'Mídia',
                url: '/media/:mediaCategory/{mediaPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/media/media-list.html`,
                controller: 'MediaListController',
                controllerAs: 'vm',
                params: {
                    mediaCategory: {
                        dynamic: true,
                        value: '',
                        squash: true
                    },
                    mediaPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.media-internal', {
                title: 'Visualizar Mídia',
                url: '/media/:mediaCategory/:mediaUrl?NewsId&NewsTitle',
                templateUrl: `${PATHS.PHYSICAL}/components/media/media-internal.html`,
                controller: 'MediaInternalController',
                controllerAs: 'vm'
            })

            // UNIVERSITY
            .state('app-master.default.university-root', {
                title: 'Universidade',
                url: '/university-lavpop',
                templateUrl: `${PATHS.PHYSICAL}/components/university/university-list.html`,
                controller: 'UniversityListController',
                controllerAs: 'vm'
            })
            .state('app-master.default.university', {
                title: 'Universidade',
                url: '/university-lavpop/:universityCategory/{universityPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/university/university-list.html`,
                controller: 'UniversityListController',
                controllerAs: 'vm',
                params: {
                    universityCategory: {
                        dynamic: true,
                        value: '',
                        squash: true
                    },
                    universityPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.university-internal', {
                title: 'Visualizar Vídeo',
                url: '/university-lavpop/:universityCategory/:universityUrl?NewsId&NewsTitle',
                templateUrl: `${PATHS.PHYSICAL}/components/university/university-internal.html`,
                controller: 'UniversityInternalController',
                controllerAs: 'vm'
            })

            // FILES
            .state('app-master.default.files-root', {
                title: 'Arquivos',
                url: '/files/{folderUrl:slashFix}',
                templateUrl: `${PATHS.PHYSICAL}/components/files/files-list.html`,
                controller: 'FilesListController',
                controllerAs: 'vm',
                params: {
                    folderUrl: {
                        dynamic: true,
                        value: null,
                        squash: true
                    }
                }
            })

            // NEWS
            .state('app-master.default.news-root', {
                title: 'News',
                url: '/news',
                templateUrl: `${PATHS.PHYSICAL}/components/news/news-list.html`,
                controller: 'NewsListController',
                controllerAs: 'vm'
            })
            .state('app-master.default.news', {
                title: 'News',
                url: '/news/{newsPage:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/news/news-list.html`,
                controller: 'NewsListController',
                controllerAs: 'vm',
                params: {
                    newsPage: {
                        dynamic: true,
                        value: 1,
                        squash: true
                    }
                }
            })
            .state('app-master.default.news-internal', {
                title: 'Visualizar News',
                url: '/news/internal/{newsId:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/news/news-internal.html`,
                controller: 'NewsInternalController',
                controllerAs: 'vm'
            })

            // PAYMENT SLIPS
            .state('app-master.default.payment-slips', {
                title: 'Meus Boletos',
                url: '/payment-slips',
                templateUrl: `${PATHS.PHYSICAL}/components/payment-slips/payment-slips.html`,
                controller: 'PaymentSlipsController',
                controllerAs: 'vm'
            })
    }
}());